import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/pl'
  },
  {
    path: '/:lang',
    component: () => import(/* webpackChunkName: "Root" */ '../views/Root.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
        meta: {
          scrollToTop: true
        }
      },
      {
        path: 'tryby-publiczne',
        name: 'public',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Public" */ '../views/Public.vue'),
        meta: {
          scrollToTop: true
        }
      },
      {
        path: 'tryby-chronione',
        name: 'secure',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Private" */ '../views/Private.vue'),
        meta: {
          scrollToTop: true
        }
      },
      {
        path: 'katalog-e-uslug',
        name: 'eservices',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "EServices" */ '../views/EServices.vue'),
        meta: {
          scrollToTop: true
        }
      },
      {
        path: 'pomoc',
        name: 'manual',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "Manual" */ '../views/Manual.vue'),
        meta: {
          scrollToTop: true
        }
      },
      {
        path: 'instrukcja/:tutorial', // TODO przebudować na usluga/instrukcja
        name: 'timeline',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "EServiceTimeline" */ '../views/EServiceTimeline.vue'),
        meta: {
          scrollToTop: true
        }
      },
      {
        path: '404',
        name: 'notFound',
        component: () => import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue'),
        meta: {
          scrollToTop: true
        }
      },
      {
        path: '*',
        redirect: '404'
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return window.scrollTo({ top: document.querySelector(to.hash).offsetTop, behavior: 'smooth' })
    } else if (to.matched.some(m => m.meta.scrollToTop)) {
      return window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      return false
    }
  },
  base: process.env.BASE_URL,
  routes
})

export default router
